import { Product } from '@/app/model/product';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { catchError, forkJoin, of, Subscription } from 'rxjs';
import { flatMap as _flatmap } from 'lodash';
import { factory } from '@/app/shared/app-logging';
import { OperatorsService } from '@/app/services/operators.service';
import { OperatorProgramsService } from '@/app/services/operator-programs.service';
import { ProgramProductsService } from '@/app/services/program-products.service';
import { TemplatesPriorityService } from '@/app/services/template-priority.service';
import { Operator } from '@/app/model/operator';
import { Program } from '@/app/model/program';
import { ExportService } from '@/app/services/export.service';
import { DropdownEntry } from '@/app/model/dropdown-entry';

const logger = factory.getLogger('TemplatePriorityOppComponent');
const DEFAULT: string = 'DEFAULT';
const DEFAULT_LABEL_CONTENT: string = `${DEFAULT} - ${DEFAULT} - ${DEFAULT}`;
const ALL_OPPS: string = `ALL`;
const ALL_OPPS_LABEL_CONTENT: string = `All OPERATOR - PROGRAM - PRODUCT`;
const ALL_OPPS_SEARCH: string = `ALL_SEARCH`;
const ALL_OPPS_SEARCH_LABEL_CONTENT: string = `ALL FROM SEARCH`;

@Component({
  selector: 'app-template-priority-opp',
  templateUrl: './opp.component.html',
  styleUrls: ['./opp.component.scss']
})
export class TemplatePriorityOppComponent implements OnInit, OnDestroy {

  private subscriptions$: Subscription[] = [];

  @Input() lengthByScreen: number = 4;

  public classFilter = "visually-hidden";
  public oppsDropdownIsLoading: boolean = false;
  public editEnabled: boolean = false;
  public products: Product[] = [];
  public dropdownEntries: DropdownEntry[] = [];
  public noResultsFound: boolean = false;
  public dropdownSelectedEntries: DropdownEntry[] = [];
  // public dropdownSelectedValue: string = '';
  // public dropdownSelectedIndexes: number[] = [];
  public dropdownSearchValue: string = '';
  public dropdownIsOpen: boolean = false;

  // public customDsyListConfObject = {
  //   maxHeight: "200px",
  //   maxWidth: "auto",
  //   minHeight: "200px",
  //   minWidth: "auto",
  //   overflow: "auto"
  // };
  public customDsyInputMultiConfObject = {
    maxHeight: "300px",
    maxWidth: "auto",
    minHeight: "100px",
    minWidth: "auto",
    overflow: "auto"
  };
  public selectedEntrie: DropdownEntry;
  public selectedFromSearch: DropdownEntry[] = [];
  saveSelectedOPPs: String[] = [];

  constructor(
    private operatorsService: OperatorsService,
    private operatorProgramsService: OperatorProgramsService,
    private programProductsService: ProgramProductsService,
    public templatePriorityService: TemplatesPriorityService,
    private exportService: ExportService
  ) {
    // Bind Dropdown Callbacks Context
    this.onDropdownSearchButtonClick = this.onDropdownSearchButtonClick.bind(this);
    this.onDropdownSearchValueChange = this.onDropdownSearchValueChange.bind(this);
  }

  ngOnInit() {
    // subscribe to template priority state changes
    this.subscriptions$.push(this.templatePriorityService.getAction().subscribe((value) => {
      if (value === 'EDIT') {
        this.editEnabled = true;
      }
      if (value === 'CANCEL' || value === 'SAVE_OK') {
        this.editEnabled = false;
      }
    }));

    this.retrieveOpps();
  }

  ngOnDestroy() {
    this.subscriptions$.forEach(sub => sub.unsubscribe());
  }

  private _buildDropdownEntries(defaultProduct: Product, allOppsProduct: Product){
    this.dropdownEntries.push({
      labelContent: `${DEFAULT} - ${DEFAULT} - ${DEFAULT}`,
      hasBorderAbove: false,
      hasBorderBelow: false,
      product: defaultProduct,
      showRightIcon: true,
      rightIconLibrary: 'material',
      rightIconSize: '16px',
      rightIconNameSelected: 'check_box',
      rightIconNameDefault: 'check_box_outline_blank',
      isSelected: true,
      show: true
    });
    this.dropdownEntries.push({
      labelContent: `${ALL_OPPS_LABEL_CONTENT}`,
      hasBorderAbove: false,
      hasBorderBelow: false,
      product: allOppsProduct,
      showRightIcon: true,
      rightIconLibrary: 'material',
      rightIconSize: '16px',
      rightIconNameSelected: 'check_box',
      rightIconNameDefault: 'check_box_outline_blank',
      isSelected: false,
      show: true
    });
    this.dropdownEntries.push({
      labelContent: `${ALL_OPPS_SEARCH_LABEL_CONTENT}`,
      hasBorderAbove: false,
      hasBorderBelow: false,
      product: this._buldAllSearchProduct(),
      showRightIcon: true,
      rightIconLibrary: 'material',
      rightIconSize: '16px',
      rightIconNameSelected: 'check_box',
      rightIconNameDefault: 'check_box_outline_blank',
      isSelected: false,
      show: false
    });
    this.products.map((productsData: any) => {
      this.dropdownEntries.push({
        labelContent: `${productsData?.program?.operator?.displayLabel} - ${productsData?.program?.displayLabel} - ${productsData?.displayLabel}`,
        hasBorderAbove: false,
        hasBorderBelow: false,
        product: productsData,
        showRightIcon: true,
        rightIconLibrary: 'material',
        rightIconSize: '16px',
        rightIconNameSelected: 'check_box',
        rightIconNameDefault: 'check_box_outline_blank',
        isSelected: false,
        show: true
      });
    });
  }
  private _getPrograms(programs) {
    logger.info('Retrieving Products...');
    this.programProductsService
      .findProductsWithProgram(programs)
      .pipe(
        catchError((err: any) => {
          logger.error('Error retrieving products', err);
          this.templatePriorityService.setError(err?.error?.message);
          return of(err);
        })
      )
      .subscribe((products) => {
        const defaultProduct: Product = this._buldDefaultProduct();
        const allOppsProduct: Product = this._buldAllOppsProduct();

        // Build Products List
        this.products.push(defaultProduct);
        this.products = this.programProductsService.sortProducts(products);

        // Build Dropdown Entries
        this._buildDropdownEntries(defaultProduct, allOppsProduct);

        this.dropdownSelectedEntries = this.dropdownEntries.filter((entry: DropdownEntry) => entry.isSelected);
        this.templatePriorityService.setDropdownSelectedEntries(this.dropdownSelectedEntries);
        this.templatePriorityService.setOpps(this.products);
        this.exportService.setIsExportEnabled(true);
        this.oppsDropdownIsLoading = false;
      });
  }
  private _getProducts(operators){
    logger.info('Retrieving Programs...');
    this.operatorProgramsService
      .findProgramsWithOperator(operators)
      .pipe(
        catchError((err: any) => {
          logger.error('Error retrieving programs', err);
          this.templatePriorityService.setError(err?.error?.message);
          return of(err);
        })
      )
      .subscribe((programs) => {
        if (programs) {
          // Load Products
        this._getPrograms(programs);
        }
      });
  }
  private retrieveOpps() {
    logger.info('Retrieving OPPs...');

    this.oppsDropdownIsLoading = true;
    forkJoin([
      this.operatorsService.findOperators().pipe(
        catchError((err) => {
          logger.error("Error retrieving operators", err);
          this.templatePriorityService.setError(err?.error?.message);
          return of(err);
        })
      ),
    ]).subscribe(([operators]) => {
      // GET PROGRAMS
      if (operators) {
        this._getProducts(operators);
      }
    });
  }
  
  clearSelectedItems(){
    this.selectedEntrie = {
      labelContent: `${DEFAULT} - ${DEFAULT} - ${DEFAULT}`,
      hasBorderAbove: false,
      hasBorderBelow: false,
      product: this._buldDefaultProduct(),
      showRightIcon: true,
      rightIconLibrary: 'material',
      rightIconSize: '16px',
      rightIconNameSelected: 'check_box',
      rightIconNameDefault: 'check_box_outline_blank',
      isSelected: true,
      show: true
    }
    this.dropdownEntries.forEach((entry: DropdownEntry) => entry.isSelected = false);
    this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id == null).isSelected = true;
    this.dropdownSelectedEntries = this.dropdownEntries.filter((entry: DropdownEntry) => entry.isSelected);
    this.onDropdownElementClicked(this.selectedEntrie);
  }

  private _buldDefaultProduct(): Product {
    return new Product(
      null,
      new Program(
        null,
        new Operator(null, DEFAULT),
        DEFAULT,
        DEFAULT,
        DEFAULT
      ),
      DEFAULT
    );
  }

  private _buldAllOppsProduct(): Product {
    return new Product(
      'ALL',
      new Program(
        null,
        new Operator(null, ALL_OPPS),
        ALL_OPPS,
        ALL_OPPS,
        ALL_OPPS
      ),
      ALL_OPPS
    );
  }
  private _buldAllSearchProduct(): Product {
    return new Product(
      'ALL_SEARCH',
      new Program(
        null,
        new Operator(null, ALL_OPPS_SEARCH),
        ALL_OPPS_SEARCH,
        ALL_OPPS_SEARCH,
        ALL_OPPS_SEARCH
      ),
      ALL_OPPS_SEARCH
    );
  }
  private _onAllSearchSelected() {
    this.dropdownEntries.forEach((entry: DropdownEntry) => {
      if(entry.product.id === ALL_OPPS || entry.product.id == null) {
        entry.isSelected = false;
      }
      if(entry.labelContent.toLowerCase().includes(this.dropdownSearchValue.toLowerCase())){
        this.selectedFromSearch.push(entry);
      }
      this.selectedFromSearch.forEach((selected: DropdownEntry) => selected.isSelected = true);
      if (entry.labelContent === `${ALL_OPPS_SEARCH_LABEL_CONTENT}`) {
        if (entry.isSelected) {
          entry.isSelected = false;
          this.selectedFromSearch = [];
          this.dropdownEntries.forEach((entries: DropdownEntry) =>
            entries.isSelected
              ? (entries.isSelected = false)
              : entries.isSelected
          );
        } else {
          entry.isSelected = true;
        }
      }
    });
  }
  private _defaultValueSelected(){
      // Selected "Default"
      this.dropdownEntries.forEach((entry: DropdownEntry) => {
        if (entry.product.id != null) {
          entry.isSelected = false;
        } else {
          entry.isSelected = true;
        }
      });
  }
  private _allOppSelected() {
    this.dropdownEntries.forEach((entry: DropdownEntry) => {
      if (entry.product.id != ALL_OPPS) {
        entry.isSelected = false;
      } else {
        // if 'ALL OPP' is already selected, remove selected.
        entry.isSelected ? entry.isSelected = false : entry.isSelected = true;
      }
    });
  }
  private _removeAllSearchSelected(saveSelectedOPPs?: String[]) {
    if (!saveSelectedOPPs) {
      this.dropdownEntries.forEach((dropdownSelected: DropdownEntry) => {
        if(!dropdownSelected.labelContent.toLowerCase().includes(this.dropdownSearchValue.toLowerCase()) && dropdownSelected.isSelected 
           && dropdownSelected.product.id !== ALL_OPPS_SEARCH) {
              this.selectedFromSearch.push(dropdownSelected);
              dropdownSelected.isSelected = true;
        } else {
          dropdownSelected.isSelected = false;
        }
      });
    } else {
      this.dropdownEntries.forEach((dropdownSelected: DropdownEntry) => {
        if(dropdownSelected.isSelected 
           && dropdownSelected.product.id !== ALL_OPPS_SEARCH && saveSelectedOPPs.includes(dropdownSelected.labelContent.toLowerCase())) {
              this.selectedFromSearch.push(dropdownSelected);
              dropdownSelected.isSelected = true;
        } else {
          dropdownSelected.isSelected = false;
        }
      });
    }
    if(this.selectedFromSearch.length === 0) {
      this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id === null).isSelected = true;
      this.selectedEntrie = this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id === null);
    }
  }
  private __otherItemsSelected(dropdownEntry: DropdownEntry){
    dropdownEntry.isSelected = !dropdownEntry.isSelected;
    this.saveSelectedOPPs.push(dropdownEntry.labelContent.toLowerCase());
    // Selected an other item, reset Default and All Opps
    this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id == null).isSelected = false;
    this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id == ALL_OPPS).isSelected = false;
    this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id === ALL_OPPS_SEARCH).isSelected = false;
  }
  private _sendOppSelected(dropdownEntryIsDefault: boolean, dropdownEntryIsAllOpps: boolean, dropdownEntryIsAllSearchOpps: boolean) {
    this.dropdownSelectedEntries = this.dropdownEntries.filter((entry: DropdownEntry) => entry.isSelected);
    if (this.dropdownSelectedEntries.length == 0) {
      // If no items are selected, select "Default"
      this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id == null).isSelected = true;
      this.dropdownSelectedEntries = this.dropdownEntries.filter((entry: DropdownEntry) => entry.isSelected);
    }
    // Send Values to Other Components
    this.templatePriorityService.setDropdownSelectedEntries(this.selectedFromSearch.length > 0 ? this.selectedFromSearch : this.dropdownSelectedEntries);
    // Enable Export again
    this.exportService.setIsExportEnabled(true);

    if (dropdownEntryIsDefault || dropdownEntryIsAllOpps || dropdownEntryIsAllSearchOpps) {
      this.dropdownIsOpen = false;
    }
  }
  private _selectedAllFromSearch(allFromSearchSelected: boolean){
    // Selected "All Search Opps"
    if(!allFromSearchSelected) {
        this._onAllSearchSelected();
    } else {
        if(this.saveSelectedOPPs.length === 0){
          this._removeAllSearchSelected();
        } else {
          this._removeAllSearchSelected(this.saveSelectedOPPs);
        }
    }
  }
  private _checkOppSelected(dropdownEntry: DropdownEntry, dropdownEntryIsDefault: boolean, dropdownEntryIsAllOpps: boolean, dropdownEntryIsAllSearchOpps: boolean) {
    if (dropdownEntryIsDefault) {
      // Selected "Default"
      this._defaultValueSelected();
    } else if (dropdownEntryIsAllOpps) {
      // Selected "All Opps"
      this._allOppSelected();
    } else if (dropdownEntryIsAllSearchOpps) {
      const allFromSearchSelected: boolean = this.dropdownEntries.find((entries: DropdownEntry) => entries.product.id === ALL_OPPS_SEARCH)?.isSelected;
      this._selectedAllFromSearch(allFromSearchSelected)
    } else {
      this.__otherItemsSelected(dropdownEntry);
    }
  }
  onDropdownElementClicked = (dropdownEntry: DropdownEntry) => {
    this.selectedFromSearch = [];
    this.selectedEntrie = dropdownEntry;
    if (this.editEnabled) return;
    // Disable Export
    this.exportService.setIsExportEnabled(false);
    // Perform logic

    const dropdownEntryIsDefault: boolean = dropdownEntry.product.id == null;
    const dropdownEntryIsAllOpps: boolean = dropdownEntry.product.id == ALL_OPPS;
    const dropdownEntryIsAllSearchOpps: boolean = dropdownEntry.product.id == ALL_OPPS_SEARCH;
    this._checkOppSelected(dropdownEntry, dropdownEntryIsDefault, dropdownEntryIsAllOpps, dropdownEntryIsAllSearchOpps);
    this._sendOppSelected(dropdownEntryIsDefault, dropdownEntryIsAllOpps, dropdownEntryIsAllSearchOpps);
  }

  onDropdownSearchButtonClick = (event) => {
    if (this.dropdownSearchValue) {
      this._activateDropdownSearch();
    }
  }
  
  onDropdownSearchValueChange = (event) => {
    this.dropdownSearchValue = event;
    if (this.dropdownSearchValue) {
      this._activateDropdownSearch();
    } else {
      this.dropdownEntries.forEach((entry: DropdownEntry) => entry.show = true);
      this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id === ALL_OPPS_SEARCH).show = false;
      this.noResultsFound = false;
    }
  }
  private _activateDropdownSearch() {
    this.dropdownEntries.forEach((entry: DropdownEntry) => {
      if (entry.labelContent.toLowerCase().includes(this.dropdownSearchValue.toLowerCase())) {
        entry.show = true;
      } else {
        entry.show = false;
      }
    });
    if(this.dropdownEntries.filter((entry: DropdownEntry) => entry.show).length > 0){
      this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id === ALL_OPPS_SEARCH).show = true;
      this.dropdownEntries.find((entry: DropdownEntry) => entry.product.id === ALL_OPPS_SEARCH).isSelected = false;
    }
    this.noResultsFound = this.dropdownEntries.filter((entry: DropdownEntry) => entry.show).length === 0;
    this.dropdownIsOpen = false;
    setTimeout(() => {
      this.dropdownIsOpen = true;
    }, 100);
  }
  
}
